<template>
  <div>
    <template v-if="user && user.account_type">
      <counselor-messages-impl
        v-if="!flag.loader && isOperator && targetUserId"
        mode="sender"
        :target_user_id="targetUserId"
      />

      <not-found
        v-if="!flag.loader && !isOperator"
      />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CounselorMessagesImpl from '@/views/pages/Common/CounselorMessagesImpl.vue';
import NotFound from '@/views/404.vue';

import cf from '@/mixins/commonFunctions';

export default {
  name: 'OperatorCounselorMessages',
  components: {
    CounselorMessagesImpl,
    NotFound,
  },
  data() {
    return {
      flag: {
        loader: true,
      },
    };
  },
  computed: {
    ...mapState(['user']),
    isOperator() {
      return this.user && this.user.account_type === 31;
    },
  },
  created() {
    // pathVariableパラメータの取得
    const slug = cf.convert2Num(this.$route.params.slug);
    this.targetUserId = slug;
    if (!slug) {
      return;
    }
    // 初期処理完了
    this.flag.loader = false;
  },
  methods: {
  },
};
</script>

<style lang="scss" module>
</style>
